import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import schoolIcon from '../../../assets/images/settings/school-icon.png';
import epay from '../../../assets/images/settings/epay.png';
import freeIcon from '../../../assets/images/settings/trial-icon.png';
import rightArrowBlue from '../../../assets/images/settings/right-arrow-blue.png';
import rightArrowWhite from '../../../assets/images/profile/right-arrow-white.png';
import codeIcon from '../../../assets/images/profile/methods/code.png';
import Api from '../../../__helpers/api';
import { useHistory } from 'react-router-dom'

//images
import boxImage from '../../../assets/images/profile/methods/box.png'
import tradeObjectsIcon from '../../../assets/images/profile/methods/trade-objects.png'
import emag from '../../../assets/images/profile/methods/emag.png'
import helikon from '../../../assets/images/profile/methods/helikon.png'
import booktrading from '../../../assets/images/profile/methods/booktrading.png'
import ozone from '../../../assets/images/profile/methods/ozone.png'
import ciela from '../../../assets/images/profile/methods/ciela.png'
import storebg from '../../../assets/images/profile/methods/storebg.png'
import locationIcon from '../../../assets/images/profile/methods/location.png'

//actions
import { handleOnlineStores } from '../../../__actions/tradeObjects'

//dispatcher
import { useDispatch } from 'react-redux'

function Methods(props) {
    const dispatch = useDispatch()
    const history = useHistory()

    const [method, setMethod] = useState({
        epayHash: '',
        epayUrl: '',
        epayPage: '',
        epayEncoded: '',
        epayChecksum: '',
    });

    const successUrl = `https://avtoobuchenie.bg/${props.callbackUrl}?success=1&hash=${method.epayHash}`;
    const cancelUrl = `https://avtoobuchenie.bg/${props.callbackUrl}?fail=1&hash=${method.epayHash}`;

    // const successUrl = `http://localhost:3000/${props.callbackUrl}?success=1&hash=${method.epayHash}`;
    // const cancelUrl = `http://localhost:3000/${props.callbackUrl}?fail=1&hash=${method.epayHash}`;


    const epayFormRef = useRef(null)

    const handleEpay = e => {
        let activationUrl = 'payment/epay';
        Api.post(activationUrl)
            .then(res => {
                setMethod(method => {
                    return {
                        ...method,
                        epayHash: res.data.HASH,
                        epayUrl: res.data.URL,
                        epayPage: res.data.PAGE,
                        epayEncoded: res.data.ENCODED,
                        epayChecksum: res.data.CHECKSUM,
                    }
                })
            })
    }

    useEffect(() => {
        // alert(1)
        if (method.epayUrl.length > 1) {
            epayFormRef.current.submit()
        }
    }, [method.epayUrl, method.epayHash])


    const handleActivate = () => {
        props.activate(false)
    }

    const tradeObjects = () => {
        dispatch(handleOnlineStores())
        props.handleClose()
        history.push(`trade-objects?from_activation=1&last_url=${history.location.pathname}`)
    }


    return (
        <ul id="methodsComponent">
            <li
                onClick={() => props.handleActivete()}
                className="code-activation"
            >
                <img src={codeIcon} alt="Код" />
                <h3>
                    Активирай с код
                </h3>
                <p>
                    <img src={boxImage} />
                        Кодът за активиран
                    се намира в кутията
                    на Авто Обучение
                </p>
                <div className="bottom">
                    <h5>
                        Активирай
                        <img src={rightArrowWhite} alt="arrow" />
                    </h5>
                </div>
            </li>
            <li onClick={handleEpay} className={props.toggle ? 'toggle' : ''}>
                <form method="post" id="epayForm" ref={epayFormRef} action={method.epayUrl}>
                    <input name="PAGE" value={method.epayPage} hidden />
                    <input name="ENCODED" value={method.epayEncoded} hidden />
                    <input name="CHECKSUM" value={method.epayChecksum} hidden />
                    <input name="URL_OK" value={successUrl} hidden />
                    <input name="URL_CANCEL" value={cancelUrl} hidden />
                </form>

                <img src={epay} alt="epay" className="epay-icon" />
                <h3>
                    Директно активиране
                </h3>
                <p>
                    Започни своето Авто Обучение.
                </p>
                <div className="bottom">
                    <div className="price">
                        <h6>
                            29<span>90</span><i>лв.</i>
                        </h6>
                        <p>
                            Цена с вкл. ДДС
                        </p>
                        {/* <p>
                            Период на валидност - 3 месеца.
                        </p> */}
                    </div>
                    <h5>
                        Купи и Активирай
                        <img src={rightArrowWhite} alt="arrow" />
                    </h5>
                </div>
            </li>
            <h2 className="on-mobile">
                Намери Авто Обучение
            </h2>
            <li className="trade-objects">
                <img src={tradeObjectsIcon} alt="school" />
                <h3>
                    В търговската мрежа
                </h3>
                <div className="brands">
                    <a
                        href="https://www.emag.bg/avto-obuchenie-r-multimedijno-interaktivno-uchebno-pomagalo-za-kandidat-shof-ori-ao-2021/pd/DDLJKDMBM"
                        target="_blank"
                        onClick={() => dispatch(handleOnlineStores('emag'))}
                    >
                        <img src={emag} />
                    </a>
                    <a
                        href="https://helikon.bg/227579-Авто-Обучение-за-кандидат-шофьори-(мултимедийно-интерактивно-учебно-помагало).html"
                        target="_blank"
                        onClick={() => dispatch(handleOnlineStores('helikon'))}
                    >
                        <img src={helikon} />
                    </a>
                    <a
                        href="https://www.booktrading.bg/avto-obuchenie"
                        target="_blank">
                        <img src={booktrading}
                            onClick={() => dispatch(handleOnlineStores('booktrading'))}
                        />
                    </a>
                    <a
                        href="https://www.ozone.bg/product/avto-obuchenie-za-kandidat-shofyori-multimediyno-interaktivno-uchebno-pomagalo"
                        target="_blank"
                        onClick={() => dispatch(handleOnlineStores('ozone.bg'))}
                    >
                        <img src={ozone} />
                    </a>
                    <a
                        href="https://ciela.com/avto-obuchenie-za-kandidat-shofyori.html"
                        target="_blank"
                        onClick={() => dispatch(handleOnlineStores('ciela'))}
                    >
                        <img src={ciela} />
                    </a>
                    <a
                        href="https://www.book.store.bg/p300380/avto-obuchenie-za-kandidat-shofiori-2021-kategorii-b-b1-be-am-a-a1-a2-tkt-i-ttm.html"
                        target="_blank"
                        onClick={() => dispatch(handleOnlineStores('store.bg'))}
                    >
                        <img src={storebg} />
                    </a>
                </div>
                <span className="near" onClick={tradeObjects}>
                    <img src={locationIcon} />
                    Близо до теб
                </span>
            </li>
            <li className={props.toggle ? 'from-school toggle' : 'from-school'}>
                <img src={schoolIcon} alt="school" />
                <h3>
                    От твоята автошкола
                </h3>
                <p>
                    Вземи учебно помагало Авто Обучение от твоя преподавател или инструктор. Авто Обучение заедно с твоята автошкола подобряваме качеството на обучение в България.
                </p>
            </li>
            <li className="or">
                ИЛИ
            </li>
            <li onClick={handleActivate} className="trial">
                <h3>
                    <img src={freeIcon} alt="trial" />
                    Започнете с Тема 1 безплатно
                </h3>
                <p>
                    Гледай видео уроците на Тема 1 напълно безплатно
                </p>
                <h5>
                    Активирайте по-късно
                    <img src={rightArrowWhite} alt="arrow" />
                </h5>
            </li>
        </ul>
    )
}

export default Methods;